import { useAuthStore } from '@/utils/stores/useAuthStore';
import { useUserStore } from '@/utils/stores/useUserStore';
import { LogOut, Menu, PersonStanding, Settings } from 'lucide-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface VenereUserMenuProps {
  className?: string;
  buttonClassName?: string;
  menuClassName?: string;
}

export const VenereUserMenu: React.FC<VenereUserMenuProps> = ({
  className = '',
  buttonClassName = '',
  menuClassName = '',
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  const { userData } = useUserStore();

  const handleLogout = () => {
    setIsMenuOpen(false);
    logout(navigate);
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  // Get user initials for avatar
  const getUserInitials = () => {
    const firstName = userData.name || '';
    const lastName = userData.familyName || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={handleMenuToggle}
        className={`p-2 bg-white hover:bg-[#768289]/10 rounded-lg transition-colors ${buttonClassName}`}
        title="Account menu"
      >
        <Menu size={20} className="venere-text-royal" />
      </button>

      {/* Dropdown Menu */}
      {isMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40"
            onClick={handleMenuClose}
          />
          
          {/* Menu Content */}
          <div className={`absolute right-0 top-16 min-w-[200px] max-w-[280px] bg-white rounded-xl shadow-lg border border-solid border-gray-200 z-50 py-2 ${menuClassName}`}>
            {/* User Info */}
            <div className="px-4 py-3 border-b border-gray-100">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 venere-bg-royal rounded-full flex items-center justify-center venere-text-matcha font-semibold text-xs">
                  {getUserInitials()}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-medium venere-text-navy text-sm truncate">
                    {userData.name} {userData.familyName}
                  </div>
                  <div className="venere-text-charcoal text-xs truncate">
                    {userData.email}
                  </div>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="py-1">
              <button
                onClick={() => {
                  // TODO: Navigate to settings/profile page
                  setIsMenuOpen(false);
                }}
                className="w-full px-4 py-2 text-left text-sm venere-text-navy hover:bg-[#768289]/10 flex items-center space-x-3"
              >
                <Settings size={16} />
                <span>Settings</span>
              </button>

              <button
                onClick={() => {
                  navigate('/venere/account');
                  setIsMenuOpen(false);
                }}
                className="w-full px-4 py-2 text-left text-sm venere-text-navy hover:bg-[#768289]/10 flex items-center space-x-3"
              >
                <PersonStanding size={16} />
                <span>Account</span>
              </button>
              
              <button
                onClick={handleLogout}
                className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center space-x-3"
              >
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VenereUserMenu; 